import { useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Paper,
  Typography,
  Divider,
  Grid,
} from "@mui/material";
import AnalyticsDashboard from "../components/Analytics/AnalyticsDashboard";
import CARKanban from "../components/CAR&PAR/MainCar.jsx";
import QualityPage from "../components/QMS/QMSMain.jsx";
import ContinuousImprovement from "../components/CI/ContinuousImprovement.jsx";
import ManagementReview from "../components/MR/ManagementReview.jsx";
import InternalAudit from "../components/InternalAudit/InternalAudit.jsx";
import EquipmentCalibration from "../components/EquipmentCalibration/EquipmentCalibration.jsx";
import DocumentControl from "../components/DocumentControl/DocumentControl.jsx";
import SkillsAnalysisTraining from "../components/SkillAnalysis&traning/SkillsAnalysis&Training.jsx";
import SupplierEvaluation from "../components/SupplierEvaluation/SupplierEvaluation.jsx";
import CustomerFeedbackTracking from "../components/CustomerFeedBack/CustomerFeedbackTracking.jsx";

function TabPanel({ children, value, index }) {
  return value === index ? (
    <Box sx={{ p: { xs: 1, sm: 2, md: 1.5 } }}>{children}</Box>
  ) : null;
}
export default function MainPage() {
  const [tab, setTab] = useState(0);
  return (
    <Box>
      <Paper>
        <Box
          sx={{
            p: { xs: 1, sm: 2 },
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Tabs
            value={tab}
            onChange={(_, newTab) => setTab(newTab)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              backgroundColor: "#F5F5F5",
              borderRadius: "10px",
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: "bold",
                color: "#4F46E5", // Always use this color
                fontSize: { xs: "12px", sm: "14px" },
                "&.Mui-selected": {
                  color: "#4F46E5", // Selected tab color
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#4F46E5", // Change indicator color here
              },
            }}
          >
            <Tab label="Quality Analytics" />
            <Tab label="QMS" />
            <Tab label="CAR/PAR" />
            <Tab label="Continuous Improvement" />
            <Tab label="Equipment Calibration" />
            <Tab label="Internal Audit" />
            <Tab label="Management Review" />
            <Tab label="Document Control" />
            <Tab label="Skills Analysis & Training" />
            <Tab label="Supplier Evaluation" />
            <Tab label="Customer Feedback Tracking" />
          </Tabs>
          <Divider />
          <TabPanel value={tab} index={0}>
            <AnalyticsDashboard />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <QualityPage />
          </TabPanel>
          <TabPanel value={tab} index={2}>
            <CARKanban />
          </TabPanel>
          <TabPanel value={tab} index={3}>
            <ContinuousImprovement />
          </TabPanel>
          <TabPanel value={tab} index={4}>
            <EquipmentCalibration />
          </TabPanel>
          <TabPanel value={tab} index={5}>
            <InternalAudit />
          </TabPanel>
          <TabPanel value={tab} index={6}>
            <ManagementReview />
          </TabPanel>
          <TabPanel value={tab} index={7}>
            <DocumentControl />
          </TabPanel>
          <TabPanel value={tab} index={8}>
            <SkillsAnalysisTraining />
          </TabPanel>
          <TabPanel value={tab} index={9}>
            <SupplierEvaluation />
          </TabPanel>
          <TabPanel value={tab} index={10}>
            <CustomerFeedbackTracking />
          </TabPanel>
        </Box>
      </Paper>
    </Box>
  );
}
